// extracted by mini-css-extract-plugin
export default {"project-link":"project-card_project-link__v8P78","card":"project-card_card__+u2db","image":"project-card_image__ZeHsd","description":"project-card_description__X8nD3"};